/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_ColumnInputs */



/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Payment_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_column = /** @type {((inputs?: Payment_ColumnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_ColumnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paiement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pago")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pagamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagamento")
	return /** @type {LocalizedString} */ ("Payment")
});